import React from "react";

const defaultWrapper = children => <React.Fragment>{children}</React.Fragment>;

export const ConditionalWrapper = ({
  condition,
  trueWrapper = defaultWrapper,
  falseWrapper = defaultWrapper,
  children
}) => (condition ? trueWrapper(children) : falseWrapper(children));
